// core/audit — logging aksi sensitif fraud (§26 v20). Best-effort (tak memblok aksi utama).
import { supabase } from './supabase';
import { currentUser } from './session';

export interface AuditEntry {
  action: string; module: string; refId?: string | null; outlet?: string | null;
  before?: unknown; after?: unknown; reason?: string | null; meta?: unknown;
}

export async function logAudit(a: AuditEntry): Promise<void> {
  try {
    const u = currentUser();
    const { error } = await supabase().from('audit_log').insert({
      action: a.action, module: a.module, ref_id: a.refId ?? null, outlet: a.outlet ?? null,
      actor_id: u?.id ?? null, actor_nama: u?.nama ?? null, actor_role: u?.role ?? null,
      before: (a.before ?? null) as object | null, after: (a.after ?? null) as object | null,
      reason: a.reason ?? null, meta: (a.meta ?? null) as object | null,
    });
    if (error) console.warn('[audit] gagal:', error.message);
  } catch (e) { console.warn('[audit] error:', e); }
}
